import { useViewType, ViewType } from '@eika/hooks';

const useHasView = (views: ViewType[]) => {
    const viewType = useViewType();
    return views?.some((view) => view === viewType);
};

export default useHasView;
